// 埋点上报脚本初始化状态
let scriptDOMStatus = 0; // 0: 未初始化 1: 初始化中 2: 初始化完成

let erp = 'unknow';

// 在模块创建的时候无法拿到模块，所以不能直接import store
// 主要是因为模块依赖混乱导致
function injectStore(store: { subscribe: any; getState: any }) {
  // 监听store获取erp信息
  store.subscribe(function () {
    const allState = store.getState();
    const userErp = allState.userInfo.userMap && allState.userInfo.userMap.erp;
    if (userErp === erp) return;
    erp = userErp;
  });
}

// 需要上报的额额外信息
function getExtInfo() {
  return {
    erp,
    href: window.location.href,
  };
}

const cacheQueue: { title: string; errorDetail: object }[] = [];

// 上报异常到 http://watchtower.jd.com/ 平台
// 目前同一个页面同一个异常只上报一次
// 并且上报会因为平台问题漏掉
function reportError(title: string, error: unknown = 'unknow') {
  if (scriptDOMStatus === 2) {
    (window as any).Watchtower.catchExp({
      title,
      errorDetail: { ...getExtInfo(), error },
    });
    return;
  }

  if (scriptDOMStatus === 0) {
    console.log('异常上报开始初始化');
    let script = document.createElement('script');

    // 可以从任意域（domain），加载任意脚本
    script.src = '//misc.360buyimg.com/retail/watchtower/sdk.js';
    document.head.append(script);

    script.onload = function () {
      console.log('异常上报初始化完成');
      (window as any).Watchtower.init({
        project: 'fa5492041ada19360ea4cf25ca3bfb55',
      });
      scriptDOMStatus = 2;

      while (cacheQueue.length) {
        const aaa = cacheQueue.shift();
        (window as any).Watchtower.catchExp(aaa);
      }
    };

    cacheQueue.push({ title, errorDetail: { ...getExtInfo(), error } });

    scriptDOMStatus = 1;
    return;
  }

  // 异常上报初始化中
  if (scriptDOMStatus === 1) {
    cacheQueue.push({ title, errorDetail: { ...getExtInfo(), error } });
    return;
  }
}

export default reportError;

export { injectStore };
